import { render, staticRenderFns } from "./DetailRowSubTable.vue?vue&type=template&id=119bafaf&scoped=true"
import script from "./DetailRowSubTable.vue?vue&type=script&lang=js"
export * from "./DetailRowSubTable.vue?vue&type=script&lang=js"
import style0 from "./DetailRowSubTable.vue?vue&type=style&index=0&id=119bafaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119bafaf",
  null
  
)

export default component.exports